
import React, {FC} from 'react';
import Button from 'components/Button';
import {NavProps} from 'components/Header';
import MenuNav, {Explore, Groups} from 'components/Header/MenuNav';
import {handleClick} from 'components/Header/MenuNav/Group/Link/Link';
import {SignIn, YourAccount} from 'components/Header/MenuNav/IconLinks';
import {Routes} from 'constants/index';
import {usePermissions} from 'hooks/usePermissions';

import * as styles from './styles.module.scss';
import * as linkStyles from 'components/Header/MenuNav/Group/Link/styles.module.scss';

const Book: FC<NavProps> = ({nav}) => (
	<Button
		className={styles.btn}
		variant='ol-green'
		onClick={handleClick(nav, Routes.booking)}
	>
		Book an appointment
	</Button>
);

const MobileNav: FC<NavProps> = ({nav}) => {
	const {auth} = usePermissions();
	return (
		<MenuNav className={linkStyles.highlightEnable}>
			{auth.isValidUser() ? (
				<YourAccount nav={nav} />
			) : (
				<SignIn nav={nav} />
			)}
			<Explore />
			<Groups nav={nav}>
				{(groups) => (
					<>
						{groups}
						<Book nav={nav} />
					</>
				)}
			</Groups>
		</MenuNav>
	);
};

export default MobileNav;
